import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import API_ENDPOINTS from "../apiConfig";
import { Team } from "../interfaces";

interface TeamsContextType {
  teams: Team[];
}

const TeamsContext = createContext<TeamsContextType>({ teams: [] });

export const useTeams = () => useContext(TeamsContext);

export const TeamsProvider = ({ children }: { children: ReactNode }) => {
  const [teams, setTeams] = useState<Team[]>([]);

  useEffect(() => {
    // Fetch teams from API endpoint
    const fetchTeams = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.teams);
        if (!res.ok) throw new Error("Failed to fetch teams");
        const data = await res.json();
        setTeams(Array.isArray(data) ? data : []);
      } catch (err) {
        setTeams([]);
      }
    };
    fetchTeams();
  }, []);

  return (
    <TeamsContext.Provider value={{ teams }}>{children}</TeamsContext.Provider>
  );
};
